<div class="content" >
  <app-household-search [isEduFamily]="isEduFamily" (searchByIdOrEmailEvent)="searchByIdOrEmail($event)" (searchByLastNameEvent)="searchByLastName($event)" (searchBySurveyEmailEvent)="searchByEmail($event)"></app-household-search>
  <mat-divider *ngIf="!localStorageUtil.getHouseHoldId('edu-family')"></mat-divider>
  <div class="email-card">
    <div class="email-container" *ngIf="(isEduFamily && (!localStorageUtil.getHouseHoldId('edu-family') || needEmail)) || (!isEduFamily && !getSurveyId())" >
      <mat-form-field appearance="legacy">
        <mat-label>{{ "Enter an email" | translate }}</mat-label>
        <input [formControl]="emailControl" placeholder="Email" email="true" matInput
        [required]="needEmail" />
      </mat-form-field>
    </div>
    <!-- Forms here -->
    <education-survey *ngIf="isEduFamily" [emailControl]="emailControl" [needEmail]="needEmail" [surveys]="surveys"></education-survey>
    <user-types-survey *ngIf="!isEduFamily" [emailControl]="emailControl" [searchSurvey]="searchSurvey"></user-types-survey>
  </div>
</div>
